import { render, staticRenderFns } from "./showAddressInfo.vue?vue&type=template&id=8f08af32&scoped=true&"
import script from "./showAddressInfo.vue?vue&type=script&lang=js&"
export * from "./showAddressInfo.vue?vue&type=script&lang=js&"
import style0 from "./showAddressInfo.vue?vue&type=style&index=0&id=8f08af32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f08af32",
  null
  
)

export default component.exports